import { render, staticRenderFns } from "./NavigationMainTitlesNeighbourhood.vue?vue&type=template&id=d4b84c9e&scoped=true&"
import script from "./NavigationMainTitlesNeighbourhood.vue?vue&type=script&lang=js&"
export * from "./NavigationMainTitlesNeighbourhood.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMainTitlesNeighbourhood.vue?vue&type=style&index=0&id=d4b84c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b84c9e",
  null
  
)

export default component.exports